import { type DeliveryNote } from '~/types/deliveryNote';

import { type FormDeliveryNoteFormFields } from '~/modules/ai-parser-review/components/FormDeliveryNote';

import { datetime4server, formatAsUTCDate } from '~/utils';

export const updateHeaderData = (
  draft: DeliveryNote,
  formData: FormDeliveryNoteFormFields,
) => {
  draft.header.id = formData.header.id;
  draft.header.date = formatAsUTCDate(formData.dlnDate, datetime4server);

  draft.transaction.settlement.salesAccount.id =
    formData.transaction.settlement.salesAccount.id!;
};
